import React from 'react';
import type { EditorIconProps } from './EditorIconProps';

export const LlamaNarration = ({
  color = 'currentColor',
  size = 40,
  ...props
}: EditorIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g transform="translate(7.5, 4)">
        <path
          d="M12.0543 0.329745C11.8431 0.118613 11.5568 0 11.2582 0H3.37746C1.51214 0 0 1.51214 0 3.37746V21.3906C0 23.2559 1.51214 24.7681 3.37746 24.7681H9.07307C9.69484 24.7681 10.1989 24.264 10.1989 23.6422C10.1989 23.0205 9.69484 22.5164 9.07307 22.5164H3.37746C2.75569 22.5164 2.25164 22.0124 2.25164 21.3906V3.37746C2.25164 2.75569 2.75569 2.25164 3.37746 2.25164H10.7919L18.0131 9.47289V12.7403C18.0131 13.3621 18.5172 13.8661 19.1389 13.8661C19.7607 13.8661 20.2648 13.3621 20.2648 12.7403V9.00656C20.2648 8.70798 20.1462 8.42162 19.935 8.21049L12.0543 0.329745Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.384 7.88074H19.1389C19.7607 7.88074 20.2647 8.38479 20.2647 9.00656C20.2647 9.62834 19.7607 10.1324 19.1389 10.1324H11.2581C10.6364 10.1324 10.1323 9.62834 10.1323 9.00656V1.12582C10.1323 0.504047 10.6364 0 11.2581 0C11.8799 0 12.384 0.504047 12.384 1.12582V7.88074Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.7701 18.4881L23.0908 14.2315C23.8279 13.6418 24.9199 14.1666 24.9199 15.1106V30.8721C24.9199 31.8161 23.8279 32.3409 23.0908 31.7512L17.7701 27.4946H13.6617C13.0399 27.4946 12.5359 26.9906 12.5359 26.3688V19.6139C12.5359 18.9921 13.0399 18.4881 13.6617 18.4881H17.7701ZM22.6683 17.453L18.8683 20.493C18.6687 20.6527 18.4206 20.7397 18.165 20.7397H14.7875V25.243H18.165C18.4206 25.243 18.6687 25.33 18.8683 25.4897L22.6683 28.5297V17.453Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

LlamaNarration.displayName = 'LlamaNarration';
